import { render } from "./edit-sales.vue?vue&type=template&id=24701618"
import script from "./edit-sales.vue?vue&type=script&lang=js"
export * from "./edit-sales.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-MakProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__